import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { FormContainer, FormField, FormGroup, InputLable, FormSubmit, ForgotPassBtn } from '../styled/forms';
import { login, forgotPassword } from '../../reducers/authActions';
import { StateInterface } from '../../interfaces/StateInterfaces';
import { ActionsInterface, ForgotPassword } from '../../interfaces/ActionInterfaces';
import { HeaderOne } from '../styled/common';
import logo from '../../assets/images/eu.jpg';
const Login: React.FC<StateInterface & ActionsInterface & ForgotPassword> = ({
    login,
    forgotPassword,
    authState: {
        isAuth,
        user: { _id },
    },
}) => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        emailForgot: '',
    });
    const [isHidden, setIsHidden] = useState(true);

    if (isAuth && _id) {
        return <Redirect to='/' />;
    }
    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.currentTarget.name]: e.target.value });
    };

    const test = (e: React.FormEvent) => {
        e.preventDefault();
        login(formData);
    };
    const showHideForgotenPass = (e: React.MouseEvent) => setIsHidden(!isHidden);
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '30px',
                    maxWidth: '80%',
                    gap: '20px',
                }}
            >
                <img src={logo} alt='' style={{ maxHeight: '80px' }} />
                <p style={{ fontSize: '14px' }}>
                    Този софтуер е създаден с финансовата подкрепа на Оперативна програма „Иновации и
                    конкурентоспособност“ 2014-2020, съфинансирана от Европейския съюз чрез Европейския фонд за
                    регионално развитие по проект BG16RFOP002-2.024-0700-C01 „Създаване на ново предприятие за
                    производство на високо-ефективни и екологични системи за отопление“. Цялата отговорност за
                    съдържанието му се носи от „Иновативни технологии за лъчисто отопление“ ООД и при никакви
                    обстоятелства не може да се приема, че информацията в него отразява официалното становище на
                    Европейския съюз и Управляващия орган.
                </p>
            </div>
            <HeaderOne>Вход</HeaderOne>
            <FormContainer onSubmit={test}>
                <FormGroup>
                    <FormField type='email' name='email' onChange={onChangeHandler} value={formData.email} />
                    <InputLable htmlFor='email'>Емейл</InputLable>
                </FormGroup>
                <FormGroup>
                    <FormField type='password' name='password' onChange={onChangeHandler} value={formData.password} />
                    <InputLable htmlFor='password'>Парола</InputLable>
                </FormGroup>
                <FormGroup>
                    <FormSubmit type='submit'>Вход</FormSubmit>
                </FormGroup>
                <FormGroup>
                    <ForgotPassBtn type='reset' onClick={showHideForgotenPass}>
                        Забравена парола?
                    </ForgotPassBtn>
                </FormGroup>
                <FormGroup style={{ display: isHidden ? 'none' : 'block' }}>
                    <FormField
                        type='test'
                        name='emailForgot'
                        onChange={onChangeHandler}
                        value={formData.emailForgot}
                        placeholder='Email...'
                    />
                    <InputLable htmlFor='emailForgot'>Посочете имейл за промяна на парола</InputLable>
                    <FormSubmit
                        type='button'
                        style={{ marginTop: '30px' }}
                        onClick={forgotPassword.bind(undefined, formData.emailForgot)}
                    >
                        Смени Парола
                    </FormSubmit>
                </FormGroup>
            </FormContainer>
        </>
    );
};
const mapStateTopProps = (state: StateInterface) => ({
    authState: state.authState,
});
export default connect(mapStateTopProps, { login, forgotPassword })(Login);
